import { TABS } from "../constants/tabs";

/* ── Tab icons — plain inline SVGs, no extra dependency needed.
     Each takes `active` to swap weight slightly for the selected
     state, matching the existing blue-500 active color. ── */
const IconFeed = ({ active }) => (
  <svg className="w-[18px] h-[18px]" viewBox="0 0 24 24" fill={active ? "currentColor" : "none"} stroke="currentColor" strokeWidth={active ? 0 : 1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 11L21 3l-6.5 18-3.5-7.5L3 11z" strokeLinejoin="round" />
  </svg>
);

const IconChats = ({ active }) => (
  <svg className="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
  </svg>
);

const IconAssets = ({ active }) => (
  <svg className="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="6" width="18" height="13" rx="2" />
    <path d="M3 10h18" />
    <circle cx="16" cy="14" r="1.2" fill="currentColor" stroke="none" />
  </svg>
);

const IconP2P = ({ active }) => (
  <svg className="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5" cy="6" r="2" />
    <path d="M2 18c0-2.5 1.3-4 3-4s3 1.5 3 4" />
    <circle cx="19" cy="6" r="2" />
    <path d="M16 18c0-2.5 1.3-4 3-4s3 1.5 3 4" />
    <path d="M9 11h6" />
    <path d="M11 9l-2 2 2 2" />
    <path d="M13 9l2 2-2 2" />
  </svg>
);

export default function BottomTabs({ activeTab, onChangeTab, chatCount = 0, feedCount = 0 }) {
  /* --------------------------------
     UNIFIED NAV — always Chats | Feed | Assets | P2P
     (Connect, Interactions, Notifications, and Profile no
     longer appear in the bottom bar; reach them elsewhere,
     e.g. from Home / the profile overlay.)
  -------------------------------- */
  return (
      <div className="bottom-tabs-inner flex justify-around py-1">
      {/* FEED */}
      <button
        onClick={() => onChangeTab(TABS.FEED)}
        className={`flex flex-col items-center gap-0.5 text-[11px] ${
          activeTab === TABS.FEED ? "font-semibold text-blue-500" : ""
        }`}
      >
      <span className="relative">
  <IconFeed active={activeTab === TABS.FEED} />
  {activeTab !== TABS.FEED && feedCount > 0 && (
    <span className="absolute -top-1.5 -right-2.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-blue-500 px-1 text-[10px] font-semibold leading-none text-white">
      {feedCount > 99 ? "99+" : feedCount}
    </span>
  )}
</span>
Feed
      </button>

      {/* CHATS */}
      <button
        onClick={() => onChangeTab(TABS.CHATS)}
        className={`flex flex-col items-center gap-0.5 text-[11px] ${
          activeTab === TABS.CHATS ? "font-semibold text-blue-500" : ""
        }`}
      >
               <span className="relative">
          <IconChats active={activeTab === TABS.CHATS} />
          {activeTab !== TABS.CHATS && chatCount > 0 && (
            <span className="absolute -top-1.5 -right-2.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-green-600 px-1 text-[10px] font-semibold leading-none text-white">
              {chatCount > 99 ? "99+" : chatCount}
            </span>
          )}
        </span>
        Chats
      </button>

      {/* ASSETS */}
      <button
        onClick={() => onChangeTab(TABS.ASSETS)}
        className={`flex flex-col items-center gap-0.5 text-[11px] ${
          activeTab === TABS.ASSETS ? "font-semibold text-blue-500" : ""
        }`}
      >
        <IconAssets active={activeTab === TABS.ASSETS} />
        Assets
      </button>

      {/* P2P */}
      <button
        onClick={() => onChangeTab(TABS.P2P)}
        className={`flex flex-col items-center gap-0.5 text-[11px] ${
          activeTab === TABS.P2P ? "font-semibold text-blue-500" : ""
        }`}
      >
        <IconP2P active={activeTab === TABS.P2P} />
        P2P
      </button>
    </div>
  );
}